import React, { Fragment, useEffect, useState } from 'react'
import { useHistory, matchPath } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { Drawer, Menu } from 'antd'
import Animate from 'rc-animate'

import { useAppSelector } from '_src/store/hooks'

import Icon from '../Icon'
import { navs, marketUrl } from './navs'

import './index.less'
import useSafeState from '../../hooks/useSafeState'

const PassMenu = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const { activeUrl } = useAppSelector((store) => store.menu)
  const isVideoRoute = matchPath(activeUrl, { path: '/video/:id?', exact: false })
  const [visible, setVisible] = useState(false)
  const [show, setShow] = useState(0)

  const [openKeys, setOpenKeys] = useSafeState([marketUrl])

  const goLink = (item, type = 'pc') => {
    if (Object.prototype.hasOwnProperty.call(item, 'children')) return

    const { url = '', link_url = '' } = item
    type == 'mobile' && onClick()
    // 创建需要权限

    url && history.push(url)
    link_url && window.open(link_url, '_blank')
    type = 'pc' && setShow(-1)
  }

  const handleMenuClick = (item) => {
    const { key = '' } = item
    // 判断是否是外部链接
    if (key.startsWith('http')) {
      onClick()
      window.open(key, '_blank') // 打开外部链接
    } else if (key && key.includes('/')) {
      goLink({ url: key }, 'mobile') // 内部跳转
    }
  }

  const handleMenuOpen = (keys) => {
    const { [keys.length - 1]: last } = keys

    if (last) {
      setOpenKeys([last])
    } else {
      setOpenKeys([])
    }
  }

  const onClick = () => {
    setVisible(!visible)
  }
  const showMenuItem = (index) => {
    setShow(index)
  }
  useEffect(() => {
    // console.log(openKeys, 'openKeys')
  }, [])
  return (
    <Fragment>
      <div className="mobile-menu-container">
        {visible ? (
          <Icon onClick={onClick} type="icon-closed" className="menu-icon" />
        ) : (
          <Icon onClick={onClick} type="icon-fold" className="menu-icon" />
        )}

        <Drawer
          onClose={onClick}
          placement="top"
          closable={false}
          open={visible}
          className="mobile-drawer-container"
          height={'auto'}
        >
          <Menu
            forceSubMenuRender={true}
            className="mobile-cust-menu-container"
            onClick={handleMenuClick}
            onOpenChange={handleMenuOpen}
            openKeys={openKeys}
            defaultOpenKeys={[marketUrl]}
            mode="inline"
            selectedKeys={isVideoRoute ? '/video' : activeUrl}
            items={navs(t, true)}
          />
        </Drawer>
      </div>
      {/*  */}
      <div className="pc-menu-container">
        {navs(t).map((item, index) => (
          <div
            key={index}
            onClick={() => {
              goLink(item)
            }}
            onMouseEnter={() => {
              showMenuItem(index)
            }}
            onMouseLeave={() => {
              setShow(-1)
            }}
            className={classNames('pc-menu-item', {
              'inft-menu-active': activeUrl && item.url && matchPath(activeUrl, { path: item.url, exact: false }),
              'inft-menu-disabled': !item.url && !item.link_url,
            })}
          >
            <div className="item-title">{item.label}</div>
            {item?.children && (
              <Animate transitionName="inft-fade" transitionAppear>
                {show == index && (
                  <div className="menu-item-container">
                    {item.children.map((it, ix) => (
                      <div
                        onClick={() => {
                          goLink(it)
                        }}
                        className={classNames('menu-item-content', {
                          'inft-menu-active': activeUrl.includes(it.url),
                        })}
                        key={ix}
                      >
                        {it.label}
                      </div>
                    ))}
                  </div>
                )}
              </Animate>
            )}
          </div>
        ))}
      </div>
    </Fragment>
  )
}

export default PassMenu
